module.exports = ".allot-details-table td{\r\n    font-size:12px;\r\n    padding:10px 5px;\r\n}\r\n\r\n/* td{\r\n    border: 1px solid #ddd;\r\n} */"


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/manual-lottery/manual-form/manual-form.component.css
// module id = ./src/app/allocation/manual-lottery/manual-form/manual-form.component.css
// module chunks = main